// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"edc24e13","443":"355b79ba","570":"949de32d"}[chunkId] + ".chunk.js";
};